<ngb-accordion class="mb-5" #acc="ngbAccordion">
	<ngb-panel>
		<ng-template ngbPanelHeader>
			<button ngbPanelToggle class="accordion-button bg-white btn btn-block text-left d-flex" (click)="clickedAccordionButton()">
				<p class="h5 ml-3 d-inline" style="color: #181c32">Observaciones</p>
				<span *ngIf="clicked" title="Item a corregir" aria-label="Item a corregir" [inlineSVG]="'./assets/media/svg/icons/Navigation/Angle-down.svg'" cacheSVG="true" class="ml-auto svg-icon svg-icon-xl svg-icon-primary"></span>
				<span *ngIf="!clicked" title="Item a corregir" aria-label="Item a corregir" [inlineSVG]="'./assets/media/svg/icons/Navigation/Angle-right.svg'" cacheSVG="true" class="ml-auto svg-icon svg-icon-xl svg-icon-primary"></span>
			</button>
		</ng-template>
		<ng-template ngbPanelContent>
            <form [formGroup]="ObservacionesGroupForm">
                <!-- Observaciones-->
                <div class="form-group">
                    <!--<label for="observaciones">Observaciones</label>-->
                    <textarea class="form-control" id="observaciones" rows="3" formControlName="observaciones" placeholder="Escriba aquí sus observaciones"></textarea>
                </div>

            </form>
        </ng-template>
	</ngb-panel>
</ngb-accordion>

